import React from "react";
import { t } from "../i18n";
import styles from "./ProfileGameSelect.module.css";
import gamesData from "./gamesData";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserAttrContext";

const games = Object.entries(gamesData).map(([name, details]) => ({
  name,
  ...details,
}));

const ProfileGameSelect = () => {
  const navigate = useNavigate();
  const { user, addFavoriteGame, removeFavoriteGame } = useUser();
  const selectedGames = user.favoriteGames || [];

  const toggleSelection = async (gameName) => {
    const game = games.find((g) => g.name === gameName);
    if (!game) return;

    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("user");
    const isSelected = selectedGames.includes(game.id);

    if (isSelected) {
      await removeFavoriteGame(game.id);

      //remove
      try {
        const res = await fetch(`${process.env.REACT_APP_API_PATH}/group-members?userID=${userId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        const memberEntry = data[0].find((entry) => entry.groupID === game.groupId);

        if (memberEntry) {
          await fetch(`${process.env.REACT_APP_API_PATH}/group-members/${memberEntry.id}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
        }
      } catch (err) {
        console.error("Failed to remove from group:", err);
      }
    } else if (selectedGames.length < 5) {
      await addFavoriteGame(game.id);

      //add
      try {
        await fetch(`${process.env.REACT_APP_API_PATH}/group-members`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userID: userId,
            groupID: game.groupId,
          }),
        });
      } catch (err) {
        console.error("Failed to add to group:", err);
      }
    }
  };

  const handleConfirm = () => {
    console.log(t("favorite_games_saved"), selectedGames);
    navigate("/profile");
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.contentContainer}>
        <div className={styles.topSection}>
          <div className={styles.selectedGamesSection}>
            {selectedGames.length > 0 ? (
              selectedGames.map((gameId, index) => {
                const game = games.find((g) => g.id === gameId);
                return (
                  <div
                    key={index}
                    className={styles.gameContainer}
                    onClick={() => toggleSelection(game.name)}
                  >
                    <img
                      src={game.carouselImage}
                      alt={game.name}
                      className={styles.gameThumbnail}
                    />
                    <button
                      className={styles.removeButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSelection(game.name);
                      }}
                    >
                      −
                    </button>
                  </div>
                );
              })
            ) : (
              <p className={styles.placeholderText}>{t("select_favorite_games")}</p>
            )}

            <div className={styles.buttonBar}>
              <span className={styles.selectionCounter}>
                {selectedGames.length}/5 {t("games")}
              </span>
              <button className={styles.confirmButton} onClick={handleConfirm}>
                {t("confirm")}
              </button>
            </div>
          </div>
        </div>

        <div className={styles.gameGrid}>
          <div className={styles.scrollableGameList}>
            {games.map((game, index) => {
              const isSelected = selectedGames.includes(game.id);
              return (
                <div
                  key={index}
                  className={styles.gameContainer}
                  onClick={() => toggleSelection(game.name)}
                >
                  <img
                    src={game.carouselImage}
                    alt={game.name}
                    className={styles.gameThumbnail}
                  />
                  {isSelected && <div className={styles.checkmark}>✔</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileGameSelect;
